import { Button, Link, Notice, Table, Text } from "@smooth/design-system-components"
import NextLink from "next/link"
import { useRouter } from "next/router"
import { useBankTransferInvoices } from "../hooks/useBankTransferInvoices"
import Pagination from "src/components/tailwind-components/Pagination"

const COLUMNS = [
  { key: "bankTransferResults", header: "Bank Transfer Results" },
  { key: "user", header: "User" },
  { key: "paymentPromise", header: "Payment Promise" },
  { key: "id", header: "Id" },
]

/** 振込請求の一覧。admin と同じ列を ID の新しい順に出す */
export const BankTransferInvoiceList = ({ page }: { page: number }) => {
  const router = useRouter()
  const { bankTransferInvoices, pagination, error, isLoading } = useBankTransferInvoices(page)

  if (error) return <Notice tone="error">一覧を取得できませんでした</Notice>
  if (isLoading) return <Text>読み込み中...</Text>

  const rows = bankTransferInvoices.map((invoice) => ({
    id:
      invoice.id === null ? null : (
        <Link href={`/admin/bank-transfer-invoices/${invoice.id}`}>{invoice.id}</Link>
      ),
    user:
      invoice.userId === null ? null : (
        <Link href={`/admin/users/${invoice.userId}`}>{invoice.userId}</Link>
      ),
    paymentPromise:
      invoice.paymentPromiseId === null ? null : (
        <Link href={`/admin/payment-promises/${invoice.paymentPromiseId}`}>
          {invoice.paymentPromiseId}
        </Link>
      ),
    bankTransferResults: `${invoice.bankTransferResultIds.length}件`,
  }))

  return (
    <div className="flex flex-col gap-4">
      <div>
        <Button asChild>
          <NextLink href="/admin/bank-transfer-invoices/new">新規作成</NextLink>
        </Button>
      </div>
      <Table
        columns={COLUMNS}
        rows={rows}
        onRowClick={(index) =>
          router.push(`/admin/bank-transfer-invoices/${bankTransferInvoices[index].id}`)
        }
      />
      <Pagination
        pagination={{
          currentPage: page,
          totalPages: pagination?.totalPages ?? 1,
          totalCount: pagination?.totalCount ?? 0,
        }}
        onPageChange={(next) => router.push({ query: { ...router.query, page: next } })}
      />
    </div>
  )
}
